import React, { Component } from "react";

import {api, get, consts, getBranchOwner, mapKeys} from '@config'
import {notification} from 'antd'
import { getLocalStorageItem } from "../../../utils";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.reloadBranchData = this.reloadBranchData.bind(this)
  }

  reloadBranchData() {
    const branch = getBranchOwner() 

    const payload = resp => {
      if (resp.length) {
        
        let currentIndex = resp.findIndex(e => e.id == branch.id)
        
        if (currentIndex === -1) {
          mapKeys.forEach(key => {
            window.localStorage.removeItem(key);
          });
          window.localStorage.removeItem(consts.APIKEY);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return
        }
        
        let currentBranch = resp[currentIndex]
        
        window.localStorage.setItem(consts.ALL_BRANCHES, JSON.stringify(resp))
        window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(currentBranch))
        window.clientAPI._setCookie('branch_owner_id', currentBranch.id)
        window.clientAPI._setCookie('branch_state_name', currentBranch.address.state)

        if(currentBranch.company){
          window.clientAPI._setCookie('branch_owner_name', currentBranch.company.fancy_name)
        }else{
          window.clientAPI._setCookie('branch_owner_name', currentBranch.name)          
        }

        notification.open({
          message: 'Dados atualizados!',
          type:'info',
          key: 2
        })

        setTimeout(() => {
          window.location.reload()
        }, 1000);

      }
    }

    get(api.branches, payload)
  }

  render() {
    return <React.Fragment>
      <div className="py-3">
        <h2>
          Detalhes da empresa
        </h2>
        <a href="/settings/branch" className="text-success">
          Acessar Configurações
        </a>
        <hr />
      </div>
      <div className="py-3">
        <h2>
          Configurações de vendas
        </h2>
        <a href="/settings/sales" className="text-success">
          Acessar Configurações de vendas
        </a>
        <hr />
      </div>
      <div className="py-3">
        <h2>
          Configurações do Perfil
        </h2>
        <a href="/profile" className="text-success">
          Acessar Configurações do seu perfil
        </a>
        <hr />
      </div>
      <div className="py-3">
        <h2>
          Planos e faturas
        </h2>
        <a href="/plans" className="text-success">
          Acessar Configurações do seu plano e suas faturas
        </a>
        <hr />
        <button onClick={this.reloadBranchData} className="btn btn-link px-0 mx-0 mt-4">Recarregar dados</button>
      </div>
    </React.Fragment>
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/pages/settings/index.jsx